import { useState, type ReactNode } from "react";
import Logo from "../assets/logo.png";
import Spinner from "../components/Spinner";

type AuthFormProps = {
    title: string;
    subtitle?: string;
    inputs: {
        label: string;
        type: "text" | "password" | "select" | "email";
        value: string;
        onChange: (val: string) => void;
        error?: string;
        placeholder?: string;
        options?: { id: string; name: string }[];
    }[];
    errorMessage: string;
    buttonText: string;
    disableButton: boolean;
    onSubmit: () => void;
    loadSpinner?: boolean;
    showLogo?: boolean;
    extra?: ReactNode;
};

const AuthForm: React.FC<AuthFormProps> = ({
    title,
    subtitle,
    inputs,
    errorMessage,
    buttonText,
    disableButton,
    onSubmit,
    loadSpinner,
    showLogo = true,
    extra,
}) => {
    const [visiblePasswords, setVisiblePasswords] = useState<Record<number, boolean>>({});

    // const togglePasswordVisibility = (index: number) => {
    //     setVisiblePasswords((prev) => ({
    //         ...prev,
    //         [index]: !prev[index],
    //     }));
    // };

    return (
        <div className="h-screen flex items-center justify-center bg-secondary">
            <div className="flex flex-col items-center w-full max-w-md p-6">
                {/* {showLogo && <img src={Logo} alt="Logo" className="w-24 h-24 mb-4" />} */}
                {showLogo && (
                    <img
                        src={Logo}
                        alt="Logo"
                        className="w-24 h-24 mb-4 border-2 border-gray-300 rounded-full shadow-md"
                    />
                )}
                <div className="mb-6 text-center">
                    <h1 className="text-2xl font-bold">{title}</h1>
                    {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
                </div>

                {inputs.map((input, idx) => (
                    <div className="w-full mb-4 relative" key={idx}>
                        <label className="block mb-1">{input.label}</label>

                        <div className="relative">
                            {input.type === "select" ? (
                                <select
                                    value={input.value}
                                    onChange={(e) => input.onChange(e.target.value)}
                                    className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                                >
                                    {/* <option value="">{input.placeholder ?? "Select option"}</option> */}
                                    {/* <option value="">{input.placeholder}</option> */}
                                    {input.options?.map(opt => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.name}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type={
                                        input.type === "password" && visiblePasswords[idx]
                                            ? "text"
                                            : input.type
                                    }
                                    value={input.value}
                                    onChange={(e) => input.onChange(e.target.value)}
                                    placeholder={input.placeholder}
                                    className="w-full border p-2 rounded pr-10 focus:outline-none focus:ring-2 focus:ring-primary"
                                />
                            )}
                        </div>

                        {input.error && (
                            <p className="text-error text-sm mt-1">{input.error}</p>
                        )}
                    </div>
                ))}

                <button
                    onClick={onSubmit}
                    disabled={disableButton}
                    className="w-full bg-primary flex items-center justify-center text-white py-2 rounded mt-4 cursor-pointer hover:bg-hoverButton disabled:opacity-60"
                >
                    {loadSpinner ? <Spinner /> : buttonText}
                </button>

                {errorMessage && (
                    <div className="text-red-700 px-4 py-2 rounded text-center mt-2">
                        {errorMessage}
                    </div>
                )}

                {extra && <div className="mt-4 w-full text-center">{extra}</div>}
            </div>
        </div>
    );
};

export default AuthForm;